import { isPast, parseISO } from 'date-fns';
import type { Banner } from '@/models/banner/banner';

export const getActiveBanners = (banners: Banner[] = []): Banner[] => {
  if (!banners.length) {
    return [];
  }

  return banners.filter((banner) => banner.active && !isPast(parseISO(banner.toDate)));
};
